exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-block{display:block;color:#ef3e55}.validated-block{display:block;color:#0078a8;opacity:1}.show{display:block}.hide{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./Scripts/app/union/components/Agreement.vue?vue&type=style&index=0&id=ec099ef8&prod&lang=css
// module id = 881
// module chunks = 0